<template>
  <div>
    <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar class="toolbar">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Raised Queries</v-toolbar-title>
          <!-- <v-toolbar-items>
            <v-btn dark text @click="show = false">Close</v-btn>
          </v-toolbar-items> -->
        </v-toolbar>
        <v-container fluid>
          <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
          </v-snackbar>
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <v-card class="box">
            <v-toolbar flat dense class="toolbar">
              <v-toolbar-title>Raised Hand Logs</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <p><b>Date*</b></p>
                <v-text-field outlined dense type="date" v-model="fromdate"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" v-if="fromdate">
                <p><b></b></p>
                <br />
                <v-btn color="warning" @click="getLogs()">Fetch</v-btn>
              </v-col>
              <v-col cols="12" md="2" sm="2">
                <p><b></b></p>
                <v-btn v-if="logs != ''" class="button" :loading="stopmarkAllResolved" @click="markAllResolved()">Mark
                  All Resolved</v-btn>
              </v-col>
              <v-col cols="12" md="2" sm="2">
                <p><b></b></p>
                <v-btn v-if="logs != ''" class="button" :loading="stopSelectedloader1"
                  @click="markselectedResolved()">Mark
                  Selected Resolved</v-btn>
              </v-col>
            </v-row>
          </v-card>

          <v-card class="box" v-if="logs != ''">
            <v-data-table :headers="headers" :items="logs" item-key="id" v-model="selected" show-select>
              <template v-slot:top>
                <v-toolbar flat class="toolbar">
                  <v-toolbar-title>Logs</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template v-slot:[`item.isresolved`]="{ item }">
                <v-switch v-model="item.isresolved" @change="saveIsResolved(item)"></v-switch>
              </template>
            </v-data-table>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  props: ["learners", "value"],
  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    selected: [],
    stopSelectedloader1: false,
    stopmarkAllResolved: false,
    total_selected: [],
    overlay: false,
    fromdate: new Date().toISOString().slice(0, 10),
    headers: [
      { text: "Sr No", value: "count" },
      { text: "Student", value: "learner" },
      { text: "Course", value: "course" },
      { text: "DateTime", value: "datetime" },
      { text: "Remark", value: "remark" },
      { text: "Academicyear", value: "academicyear" },
      { text: "Is Resolved", value: "isresolved" },
    ],
    logs: [],
  }),
  methods: {
    async markAllResolved() {
      if (!confirm("Are You Sure You Want To Mark All Resolved...?")) return;
      this.stopmarkAllResolved = true;
      var logs_ids = []
      for (var i = 0; i < this.logs.length; i++) {
        logs_ids.push(this.logs[i].id);
      }
      const data = {
        logs_ids: logs_ids
      };
      try {
        const res = await axios.post("/LiveClass/markAllResolved", data);
        if (res.data.flag == "YES") {
          this.stopmarkAllResolved = false;
        }
        if (res.data.flag == "No") {
          this.showSnackbar("red", res.data.snackbar); // show snackbar
          this.stopmarkAllResolved = false;
        }
        this.stopmarkAllResolved = false;
      } catch (error) {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        this.stopmarkAllResolved = false;
      } finally {
        this.save_loader = false;
        this.stopmarkAllResolved = false;
        this.getLogs()
      }
    },

    async markselectedResolved() {
      this.total_selected = [];
      if (!confirm("Are You Sure You Want To Mark All Resolved...?")) return;
      this.stopSelectedloader1 = true;
      for (var i = 0; i < this.selected.length; i++) {
        this.total_selected.push(this.selected[i].id);
      }
      if (this.total_selected.length <= 0) {
        this.showSnackbar("#b71c1c", "Please select Questions!"); // show snackbar
        this.stopSelectedloader1 = false;
        return;
      }
      const data = {
        logs_ids: this.total_selected
      };
      try {
        const res = await axios.post("/LiveClass/markAllResolved", data);
        if (res.data.flag == "YES") {
          this.stopSelectedloader1 = false;
          this.selected = [];
          this.showSnackbar("green", "Save Mark  Selected Resolved Successfully...");
        }
        if (res.data.flag == "No") {
          this.showSnackbar("red", res.data.snackbar); // show snackbar
          this.stopSelectedloader1 = false;
        }
        this.stopSelectedloader1 = false;
      } catch (error) {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        this.stopSelectedloader1 = false;
      } finally {
        this.save_loader = false;
        this.stopSelectedloader1 = false;
        this.getLogs()
      }
    },


    async saveIsResolved(item) {
      const data = {
        log_id: item.id,
        isresolved: item.isresolved,
      };
      this.overlay = true;
      try {
        const res = await axios.post("/LiveClass/saveIsResolved", data);
        if (res.data.flag == "YES") {
          this.showSnackbar("green", "Updated Successfully..."); // show snackbar
          this.getLogs();
        }
        if (res.data.flag == "No") {
          this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
        }
      } catch (error) {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
      } finally {
        this.overlay = false;
      }
    },
    async getLogs() {
      this.logs = [];
      const data = {
        fromdate: this.fromdate,
        learners: this.learners,
      };
      this.overlay = true;
      try {
        const res = await axios.post("/LiveClass/getRaisedHandsLogs", data);
        if (res.data.flag == "YES") {
          this.logs = res.data.logs;
        }
        if (res.data.flag == "No") {
          this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          this.logs = [];
        }
      } catch (error) {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
      } finally {
        this.overlay = false;
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    // this.onLoad();
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {},
};
</script>
<style scoped></style>